import { render, staticRenderFns } from "./TriangleSimpleIcon.vue?vue&type=template&id=52ca1be1&"
import script from "./TriangleSimpleIcon.vue?vue&type=script&lang=js&"
export * from "./TriangleSimpleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports